import React, { useEffect, useState, useContext, createContext } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { UserContext } from '../App';
import MainLayoutWrapper from './MainLayoutWrapper';
import { getLoginToken } from './../helpers/UserHelper';

export const MethodischDidactischContext = createContext(null);

function MethodischDidactischLayoutWrapper({ settings }) {
    const userContext = useContext(UserContext);
    const location = useLocation();
    const [klassen, setKlassen] = useState([]);
    const [vakken, setVakken] = useState([]);
    const [motivaties, setMotivaties] = useState([]);
    const [verwerkingen, setVerwerkingen] = useState([]);
    const [cards, setCards] = useState([]);

    const [activeKlas, setActiveKlas] = useState(null);
    const [activeVak, setActiveVak] = useState(null);
    const [activeMotivatie, setActiveMotivatie] = useState(null);
    const [activeVerwerking, setActiveVerwerking] = useState(null);

    useEffect(() => {
        if (getLoginToken() === null || userContext.fetchHeaders === null) return;

        try {
            fetch(settings.apiBaseUrl + 'methodisch-didactisch/general', {
                method: 'POST',
                headers: userContext.fetchHeaders,
            })
                .then(result => result.json())
                .then(response => {
                    if (!response.success) return;

                    setKlassen(response.methodisch_didactisch.klassen);
                    setVakken(response.methodisch_didactisch.vakken);
                    setMotivaties(response.methodisch_didactisch.motivaties);
                    setVerwerkingen(response.methodisch_didactisch.verwerkingen);
                    setCards(response.methodisch_didactisch.kaarten);
                });
        } catch (error) {
            console.error(error);
        }
    }, [userContext.fetchHeaders, settings.apiBaseUrl, location.pathname]);

    return (
        <MethodischDidactischContext.Provider value={{
            klassen,
            vakken,
            motivaties,
            verwerkingen,
            cards,
            activeKlas,
            activeVak,
            activeMotivatie,
            activeVerwerking,
            setActiveKlas: (klas) => {
                setActiveKlas(klas);
            },
            setActiveVak: (vak) => {
                setActiveVak(vak);
            },
            setActiveMotivatie: (motivatie) => {
                setActiveMotivatie(motivatie);
            },
            setActiveVerwerking: (verwerking) => {
                setActiveVerwerking(verwerking);
            }
        }}>
            <MainLayoutWrapper settings={settings}>
                <Outlet key={location.pathname} />
            </MainLayoutWrapper>
        </MethodischDidactischContext.Provider>
    );
}

export default MethodischDidactischLayoutWrapper;